import { onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import logoMobile from "../assets/images/logo-mobile.png";

let listenerInitialized = false;

// Create audio once
const notificationSound = new Audio("/notification-bell.mp3");
notificationSound.preload = "auto";

export const listenFCMMessages = (callback = null) => {

    if (listenerInitialized) return;

    listenerInitialized = true;

    onMessage(messaging, async (payload) => {

        try {

            notificationSound.currentTime = 0;
            await notificationSound.play();
        } catch (err) {
            console.log("Audio play failed:", err);
        }

        const title =
            payload?.notification?.title || "Notification";

        const body =
            payload?.notification?.body || "";

        new Notification(title, {
            body,
            icon: logoMobile,
        });

        if (callback) {
            callback(payload);
        }
    });
};